import React, { PureComponent } from "react";

export default class CheckeddIcon extends PureComponent {
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="8847 5133 18 18" {...this.props}>
				<path
					id="path"
					d="M19,3H5A2.006,2.006,0,0,0,3,5V19a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5a2.006,2.006,0,0,0-2-2ZM10,17,5,12.192l1.4-1.346L10,14.308,17.6,7,19,8.346,10,17Z"
					transform="translate(8844 5130)"
				/>
			</svg>
		);
	}
}
